export default {
  submit: 'Entregar',
  numberOfAtt: '人数',
  email: 'Correo electrónico',
  phone: '电话',
  name: 'Español',
  company: 'Empresa',
  welcome: '¡Bienvenido al stand de Truking! Por favor complete su información y le enviaremos los materiales de producto de su interés. ¡Gracias!',
  signIn: '活动签到',
  ctkj: '楚天科技',
  zhCN: '中文',
  enUs: 'English',
  esEs: 'Español',
  deDe: 'Deutsch',
  ruRu: 'Русский язык',
  new_dept: '部门/岗位',
  new_title: '职位',
  new_nation: 'País',
  new_product: '产品类型',
  requiredMsg: 'Por favor, rellene los campos obligatorios',
  successMsg: 'Presentación exitosa',
  jobNumber: '工号',
  jobNumberPlaceholder: '请输入工号',
  passwordReset: '密码重置',
  jobNumberRule1: '请填写工号',
  jobNumberRule2: '请输入正确的工号',
  verificationCode: '钉钉验证码',
  verificationCodePlaceholder: '请输入钉钉验证码',
  sendCode: '发送验证码',
  codeNotice: '验证码将发送到钉钉工作通知,有效时间2分钟',
  newPwd: '新密码',
  newPwdRule1: '请输入新密码',
  newPwdRule2: '密码需要包含字母、数字、符号（.!@#），且长度不能低于10位',
  confirmPwd: '确认新密码',
  confirmPwdRule1: '确认新密码',
  confirmPwdRule2: '两次输入密码不一致',
  backHome: '返回首页',
  changePwd: '修改密码',
  editSucess: '修改成功',
  editPwdError1: '重置密码失败，密码要求10位以上，字母+数字+特殊字符（.!@#）',
  sendSucess: '发送成功',
  sendAagain: '重新发送',
  new_tkproduct: 'Productos o soluciones de interés'
}



// WEBPACK FOOTER //
// ./src/assets/lang/es-ES.js